<div class="row text-secondary">
  <div class="col" *ngIf="showDate">
    {{ documentCategory.date | pepDate: locale }}
  </div>
  <div class="col">
    {{ category.name }}
  </div>
  <div class="col-auto text-nowrap pl-0 text-right">
    {{ documentCategory.amount | pepCurrency:currencyId:locale }}
  </div>
  <div class="col-auto buttons pl-0">
    <a href class="px-1" (click)="false"
      *ngIf="!showDate"
      ngbTooltip="{{ documentCategory.date | pepDate: locale }}" container="body"
    >
      <i class="fe fe-calendar"></i>
    </a>
    <a href class="px-1" (click)="onEdit(); false"><i class="fe fe-edit"></i></a>
    <a href class="px-1" (click)="onDelete(); false"><i class="fe fe-trash text-danger"></i></a>
  </div>
</div>
